import React, { FC, PropsWithChildren } from 'react'
import Box from '@mui/material/Box'
import { HasSidebarLayout, DataLoad, ListHeader, PropsInjector, LoRaWanSensorList, SearchForm } from 'src/components'
import { useSensorStatesRequest, useSensorTypesRequest } from 'src/hooks/api'

const SensorTypeLoader: FC<PropsWithChildren> = ({ children }) => {
  const { data, isInitialLoading, isError } = useSensorTypesRequest()
  const lorawanSensorType = data?.rows?.find((type) => type.name === 'lorawan_sensor')
  const typeId = lorawanSensorType?.id

  return (
    <DataLoad isLoading={isInitialLoading} isError={isError}>
      <PropsInjector props={{ typeId }}>{children}</PropsInjector>
    </DataLoad>
  )
}

const SensorStateLoader: FC<PropsWithChildren<{ typeId?: number }>> = ({ typeId, children }) => {
  const { data, isInitialLoading, isError } = useSensorStatesRequest()
  return (
    <DataLoad isLoading={isInitialLoading} isError={isError}>
      <PropsInjector props={{ states: data || [], typeId }}>{children}</PropsInjector>
    </DataLoad>
  )
}

const LoRaWanSensorListPage: FC = () => {
  document.title = 'CLīMIT Admin Panel - LoRaWan Sensors'
  return (
    <HasSidebarLayout>
      <ListHeader title="LoRaWan Sensors"></ListHeader>
      <Box mb={2}>
        <SearchForm />
      </Box>
      <SensorTypeLoader>
        <SensorStateLoader>
          <LoRaWanSensorList />
        </SensorStateLoader>
      </SensorTypeLoader>
    </HasSidebarLayout>
  )
}

export default LoRaWanSensorListPage
